import { PayrollIncidenceDetailsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

const useIncidenceRuleEvaluation = (
  incidenceId: number,
  employeeId: number,
  legalEntityId: number,
  companyId: number
) => {
  const { loading, data } = useQuery(PayrollIncidenceDetailsPageDocument, {
    variables: {
      id: incidenceId,
      employeeId: employeeId,
      legalEntityId: legalEntityId,
      companyId: companyId,
    },
  })
  const ruleEvaluation = data?.bookkeepersManagement?.incidencesConnection.nodes[0]?.ruleEvaluation

  return { loading, ruleEvaluation }
}

export default useIncidenceRuleEvaluation
